export enum Roles {
    ADMINISTRATOR = 'Administrator',
    EMPLOYEE = 'Employee',

    EVENTS_READER = 'EventsReader',
    EVENTS_CREATOR = 'EventsCreator',
    EVENTS_CONTRIBUTOR = 'EventsContributor',
    EVENTS_ADMINISTRATOR = 'EventsAdministrator',

    TICKETS_READER = 'TicketsReader',
    TICKETS_CREATOR = 'TicketsCreator',
    TICKETS_CONTRIBUTOR = 'TicketsContributor',
    TICKETS_ADMINISTRATOR = 'TicketsAdministrator',

    ORDERS_READER = 'OrdersReader',
    ORDERS_CONTRIBUTOR = 'OrdersContributor',
    ORDERS_ADMINISTRATOR = 'OrdersAdministrator',

    PURCHASES_READER = 'PurchasesReader',
    PURCHASES_CREATOR = 'PurchasesCreator',
    PURCHASES_CONTRIBUTOR = 'PurchasesContributor',
    PURCHASES_ADMINISTRATOR = 'PurchasesAdministrator',

    TICKET_SALES_CAP_READER = 'TicketSalesCapReader',
    TICKET_SALES_CAP_CREATOR = 'TicketSalesCapCreator',
    TICKET_SALES_CAP_CONTRIBUTOR = 'TicketSalesCapContributor',
    TICKET_SALES_CAP_ADMINISTRATOR = 'TicketSalesCapAdministrator',

    EXPORTS_CONTRIBUTOR = 'ExportsContributor',

    TICKET_MANAGEMENT = 'TicketManagement',

    // Order Comparison Tool Role
    ORDER_COMPARISON_CONTRIBUTOR = 'OrderComparisonContributor',
}

export const ALL_ROLES = Object.values(Roles);
export const ETBAAS_ROLES = Object.values(Roles).filter((role) => role !== Roles.TICKET_MANAGEMENT);
